import { Audience } from "@/features/audiences/audience-types";
import { Survey } from "@/features/surveys/survey-types";
import { storageService } from "@/services/StorageService";
import { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { GT } from "../Gt";

const NavBar = () => {
  const location = useLocation();
  const { surveyId, audienceId } = useParams();
  const [survey, setSurvey] = useState<Survey | undefined>(undefined);
  const [audience, setAudience] = useState<Audience | undefined>(undefined);
  // Gruik, could use a better state management
  useEffect(() => {
    storageService.getSurveyById(surveyId || "dummy").then(setSurvey);
    storageService.getAudienceById(audienceId || "dummy").then(setAudience);
  }, [surveyId, audienceId]);

  return (
    <nav className="w-full px-4 py-4 flex">
      <div className="inline-block mr-12 flex-none">
        <div className="flex">
          <Link to="/workspaces/VzSj79" className="text-xl font-semibold mr-4">
            <img
              src="/logo.svg"
              alt="TwinVerse Logo"
              className="h-4 w-auto inline-block mr-2"
            />
            TwinVerse
          </Link>
        </div>
      </div>

      <div className="flex-1 relative top-1 hidden sm:inline-block">
        <div className="flex">
          <Link to="/workspaces/VzSj79" className="hover:underline">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="none"
              viewBox="0 0 16 16"
              cursor="unset"
              className="relative bottom-0.5 mr-2 inline-block"
            >
              <path
                fill="currentColor"
                d="M3.324 1H6.75a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-.75.75h-5A.75.75 0 0 1 1 6.75V3.324c0-.258 0-.494.016-.692.018-.213.057-.446.175-.676a1.75 1.75 0 0 1 .765-.765c.23-.118.463-.157.676-.175C2.83 1 3.066 1 3.324 1M2.63 2.53h.001zm.002-.001a.6.6 0 0 1 .121-.018c.13-.01.304-.011.596-.011H6V6H2.5V3.35c0-.292 0-.467.011-.596a.6.6 0 0 1 .018-.12.25.25 0 0 1 .104-.105m-.103.102v.001zm10.716-.12a8 8 0 0 0-.596-.011H10V6h3.5V3.35c0-.292 0-.467-.011-.596a.6.6 0 0 0-.018-.12.25.25 0 0 0-.104-.105.6.6 0 0 0-.121-.018m.123.019h-.001zm.101.1v.002zm-.102-1.614c.213.018.446.057.676.175.33.168.598.435.765.765.118.23.158.463.175.676.016.198.016.434.016.692V6.75a.75.75 0 0 1-.75.75h-5a.75.75 0 0 1-.75-.75v-5A.75.75 0 0 1 9.25 1h3.426c.258 0 .494 0 .692.016M1 9.25a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-.75.75H3.324c-.258 0-.494 0-.692-.016a1.8 1.8 0 0 1-.676-.175 1.75 1.75 0 0 1-.765-.764 1.8 1.8 0 0 1-.175-.677C1 13.17 1 12.934 1 12.676zm1.5.75v2.65c0 .292 0 .467.011.596a.6.6 0 0 0 .018.12.25.25 0 0 0 .104.105.6.6 0 0 0 .121.018c.13.01.304.011.596.011H6V10zm.13 3.47h.002zm-.1-.1v-.002zM8.5 9.25a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 .75.75v3.426c0 .258 0 .494-.016.692a1.8 1.8 0 0 1-.175.676 1.75 1.75 0 0 1-.764.765c-.23.118-.464.158-.677.175-.198.016-.434.016-.692.016H9.25a.75.75 0 0 1-.75-.75zM10 10v3.5h2.65c.292 0 .467 0 .596-.011a.6.6 0 0 0 .12-.018.25.25 0 0 0 .105-.104.6.6 0 0 0 .018-.121c.01-.13.011-.304.011-.596V10zm3.47 3.37v-.002zm-.1.1h-.002z"
                fillRule="evenodd"
                clipRule="evenodd"
              ></path>
            </svg>
            My Workspace
          </Link>
          {survey && (
            <>
              <GT />
              <Link to={`/surveys/${survey.id}`} className="hover:underline">
                {survey.header?.title || "Untitled Survey"}
              </Link>
            </>
          )}
          {audience && (
            <>
              <GT />
              <Link to="#" className="hover:underline">
                {audience.name}
              </Link>
            </>
          )}
          {location.pathname === "/newsurvey" && (
            <>
              <GT />
              New Survey
            </>
          )}
          {location.pathname === "/newaudience" && (
            <>
              <GT />
              New Audience
            </>
          )}
        </div>
      </div>

      <div className="inline-block flex-none">
        <ul className="flex space-x-6">
          <li>
            <Link to="/settings" className="hover:text-slate-400">
              Settings
            </Link>
          </li>
          <li>
            <Link to="/" className="hover:text-slate-400">
              Sign out
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default NavBar;
